import PropTypes from "prop-types";
import React from "react";
import {
    Icon,
    Label,
} from "semantic-ui-react";
import { format } from "./Timestamp";

const Deadline = ({
                      ts,
                  }) => {
    const d = new Date(ts);
    const expired = d < Date.now();
    const moreThanADayLeft = (d - Date.now()) > 86400000;
    return <Label basic color={expired ? "red" : "teal"}>
        <Icon name={expired
            ? "hourglass end"
            : moreThanADayLeft
                ? "hourglass start"
                : "hourglass half"
        } />
        {format(d)}
    </Label>;
};

Deadline.propTypes = {
    ts: PropTypes.instanceOf(Date).isRequired,
};

export default Deadline;



// WEBPACK FOOTER //
// ./src/util/Deadline.js